import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import RoleCrudService from '../../services/RoleCrudService';
import PermissionEnum from './PermissionEnum';

export default function ModalRole({ show, handleClose, dataItem, setRenderRows }) {

  const [currentRole, setCurrentRole] = useState(false);
  const [AllowAccess, setAllowAccess] = useState([]);
  const [ModulesCheked, setModulesCheked] = useState([]);

  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;

  const [roleName, setRoleName] = useState(currentRole.code);
  const [roleDescription, setRoleDescription] = useState(currentRole.description);
  const [enableSaveChanges, setEnableSaveChanges] = useState(true);

  useEffect(() => {
    if (show && dataItem.codeItem > 0) {
      RoleCrudService.getRoleById(dataItem.codeItem).then(async res => {
        setCurrentRole(res.data.data[0]);
      });
    } else {
      setCurrentRole(false);
      setAllowAccess([]);
      setModulesCheked([]);
      setEnableSaveChanges(true);
    }
  }, [dataItem, show]);

  useEffect(() => {
    if (show && currentRole.permissions && !AllowAccess.length) {
      PermissionEnum.map((type) => {
        const userPermits = currentRole.permissions;
        const filtered = userPermits.filter(validItem => validItem === type || validItem.startsWith(type + '_'));
        let read = 0;
        let write = 0;

        if (filtered.length > 0) {
          let nameView = filtered[0].split('_');
          let pieces = nameView[1].split("");
          read = (pieces[0] === 'R') ? 1 : 0;
          write = (pieces[1] === 'W') ? 1 : 0;

          if (read) {
            setModulesCheked(ModulesCheked => [...ModulesCheked, (type + '_R')]);
          }
          if (write) {
            setModulesCheked(ModulesCheked => [...ModulesCheked, (type + '_W')]);
          }
        }

        let item = { 'name': type, 'R': read, 'W': write };
        setAllowAccess(AllowAccess => [...AllowAccess, item]);
        return (filtered);
      });
    }
  }, [show, currentRole, AllowAccess, ModulesCheked]);

  const handleSubmit = async () => {

    const permissionArray = [];
    PermissionEnum.map((module) => {
      const filtered = ModulesCheked.filter(validItem => validItem === module || validItem.startsWith(module + '_'));
      if (filtered.length === 1) {
        let pieces = filtered[0].split("_");
        let write = (pieces[1] === 'W') ? 1 : 0;

        if (write)
          permissionArray.push(module + '_RW');
        else
          permissionArray.push(module + '_R');

      } else if (filtered.length === 2) {
        permissionArray.push(module + '_RW');
      }
      return module;
    });

    let updateRole = { name: roleName, description: roleDescription, permissions: permissionArray };

    if (!dataItem.codeItem && dataItem.typeView === 'Create') {
      RoleCrudService.createRole(updateRole).then(res => {
        handleClose();
        RoleCrudService.getAllRoles().then(async res => {
          window.location.href = '/Roles';
        });
      });
    } else {
      RoleCrudService.updateRole(updateRole, dataItem.codeItem).then(res => {
        handleClose();
        RoleCrudService.getAllRoles().then(async res => {
          window.location.href = '/Roles';
        });
      });
    }
  };

  const changeRoleNameHandler = (event) => {
    setRoleName(event.target.value);
    setEnableSaveChanges(false);
  }

  const changeRoleDescriptionHandler = (event) => {
    setRoleDescription(event.target.value);
    setEnableSaveChanges(false);
  }

  const changeRolePermissionsHandler = (event) => {

    const { value, checked } = event.target;
    //console.log(`${value} is ${checked}`);
    if (checked) { // Case 1 : The role checks box
      setModulesCheked([...ModulesCheked, value]);
    } else {  // Case 2 : The role unchecks box
      setModulesCheked(ModulesCheked.filter(event => event !== value));
    }
    setEnableSaveChanges(false);
  }

  let addSubmitButton = "";

  if (!conditionView) {
    addSubmitButton = <Button type="button" disabled={enableSaveChanges} onClick={() => handleSubmit()}>Save</Button>;
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate>

            <Row className="mb-3">
              <Form.Group as={Col} md="4" controlId="validationCustom02">
                <Form.Label>NameRole</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="NameRole"
                  defaultValue={currentRole.name}
                  onChange={conditionView ? null : changeRoleNameHandler}
                  readOnly={conditionView ? true : false}
                />
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="validationCustom03">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Description"
                  defaultValue={currentRole.description}
                  onChange={conditionView ? null : changeRoleDescriptionHandler}
                  readOnly={conditionView ? true : false}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <table className="table" cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Read</th>
                    <th>Write</th>
                  </tr>
                </thead>
                <tbody>
                  {AllowAccess ? AllowAccess.map((type, indexItem) => {
                    return (
                      <tr key={indexItem}>
                        <td>
                          {type.name}
                        </td>
                        <td>
                          <Form.Check
                            inline
                            defaultChecked={type.R}
                            name="modules"
                            value={type.name + "_R"}
                            id={type.name + "_R"}
                            label="R"
                            onChange={conditionView ? null : changeRolePermissionsHandler}
                            readOnly={conditionView ? true : false}
                          />
                        </td>
                        <td>
                          <Form.Check
                            inline
                            defaultChecked={type.W}
                            name="modules"
                            value={type.name + "_W"}
                            id={type.name + "_W"}
                            label="W"
                            onChange={conditionView ? null : changeRolePermissionsHandler}
                            readOnly={conditionView ? true : false}
                          />
                        </td>
                      </tr>
                    );
                  }) : null}
                </tbody>
              </table>
            </Row>

            {addSubmitButton} {'  '}  {'  '}
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}